<script lang="ts">
  import Panel from '@components/panel.svelte'
  import Image from '@components/image.svelte'
  import type {
    FieldGoalEvent,
    GameraTeamReference,
  } from '@statmuse/core/gamera'
  import ShotChart from './shot-chart.svelte'
  import { plays, quarterClock } from './stores'

  export let awayTeam: GameraTeamReference | undefined
  export let homeTeam: GameraTeamReference | undefined

  export let awayFieldGoals: FieldGoalEvent[] | undefined
  export let homeFieldGoals: FieldGoalEvent[] | undefined

  export let domain: 'NBA' | 'WNBA' = 'NBA'

  $: currentPlays = $plays.filter((p) => p.period === $quarterClock.quarter)
  $: currentAwayFieldGoals = currentPlays.filter(
    (p): p is FieldGoalEvent =>
      p.type === 'fieldGoal' && p.teamId === awayTeam?.teamId,
  )
  $: currentHomeFieldGoals = currentPlays.filter(
    (p): p is FieldGoalEvent =>
      p.type === 'fieldGoal' && p.teamId === homeTeam?.teamId,
  )
</script>

<Panel class="!p-0 h-48 flex items-center relative">
  <ShotChart
    class="rotate-90 w-48 absolute left-0 -translate-x-1.5 text-gray-5"
    fieldGoals={awayFieldGoals ?? currentAwayFieldGoals}
    team={awayTeam}
    {domain}
  />
  <Image
    src={awayTeam?.logoImageUrl ?? ''}
    alt={awayTeam?.name ?? ''}
    width={60}
    height={60}
    class="w-4 h-4 object-contain absolute top-1.5 left-1/2 -translate-x-5"
  />
  <div class="w-[1px] h-full bg-gray-5 absolute left-1/2 -translate-x-1/2" />
  <div
    class="w-16 h-16 border border-gray-5 rounded-full absolute left-1/2 -translate-x-1/2"
  />
  <Image
    src={homeTeam?.logoImageUrl ?? ''}
    alt={homeTeam?.name ?? ''}
    width={60}
    height={60}
    class="w-4 h-4 object-contain absolute top-1.5 left-1/2 translate-x-1.5"
  />
  <ShotChart
    class="-rotate-90 w-48 absolute right-0 translate-x-1.5 text-gray-5"
    fieldGoals={homeFieldGoals ?? currentHomeFieldGoals}
    team={homeTeam}
    {domain}
  />
</Panel>
